import { render, staticRenderFns } from "./CreateDataScopeForm.vue?vue&type=template&id=a40b849e"
import script from "./CreateDataScopeForm.vue?vue&type=script&lang=js"
export * from "./CreateDataScopeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports